// extracted by mini-css-extract-plugin
export default {"cls1":"PostComments-cls1___17f5a49780a9bae706b","cls2":"PostComments-cls2___085525e970fd00e4f28 PostComments-cls1___17f5a49780a9bae706b"};